<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="visitors">
<h1>6. Visitors</h1>
<p>Returning to the ’dungeon' next morning, Jasmine found a note from Henry saying that there would be some engineers coming to see her about the equipment she needed, so she spent time sorting through her notes and drawing some rough outline sketches on her chalkboard of what she had in mind.</p>
<p>Clary arrived with her ’engineers', army officers who introduced themselves simply as Richard and Peter.</p>
<p>“So, what have you found and how are you suggesting we tackle the problem?” Richard, who appeared to be the senior of the two, asked after Clary had left.</p>
<p>After the hassle she had encountered during her presentation, Richard's attitude was most encouraging as she began to explain the potential problem, showing them her copies of the original sheets.</p>
<p>After studying the sheets, Peter had congratulated her on her sharp eyes recognising the potential problem.</p>
<p>“So, now it comes down to how we deal with this threat?”</p>
<p>“Well, I'm fairly certain whoever is setting this up would not try mixing the stuff, mixed, even on a mildly humid day, it would give off enough toxins to kill. I think, I'm hoping, that they leave everything in sacks in a skip and let water leach the stuff out and do the mixing. That does, however, rather leave things to chance, it could go bang or just fizzle and give off toxic fumes for several days.”</p>
<p>“So how do we contain it?”</p>
<p>“The only way I can think of is flood the mix with petrol, so the evaporation cools the chemical reaction, then ignite the vapour so it burns the toxic fumes with it.”</p>
<p>Richard and Peter looked at the sheets, the sketches on the chalkboard, then at each other.</p>
<p>“What do you think, Peter?”</p>
<p>“Crazy, but under the circumstances, crazy enough to work, because I can't think of an alternative.”</p>
<p>“Right Jasmine, let's get something on paper.”</p>
<p>When her visitors had left, Jasmine collected a fresh cup of tea and flopped into a chair. Although Richard and Peter had been on her side, the questions and discussions had kept her brain at full stretch, the presentation with all its interruptions and hostilities had been easier. She was half way down her tea when Clary found her.</p>
<p>“Here you are, are you going to work all evening?”</p>
<p>It was then Jasmine saw the time was gone six.</p>
<p>“Heavens, being down here I'd lost all track of the time.”</p>
<p>“Busy day?”</p>
<p>“Manic.”</p>
<p>“Well, come on, we're finished and as it is Friday, we have a treat, an evening out.”</p>
<p>“Oh, where?”</p>
<p>“Henry and Roger are taking us for a meal.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch010.vue?63c63bda